module.exports = __webpack_public_path__ + "img/SKMJ_heavy8.343e3d39.jpg";